// extracted by mini-css-extract-plugin
export default {"inner":"SeabattleLoaderPopup_inner","errorBlock":"SeabattleLoaderPopup_errorBlock"};